"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExclusiveGateway = void 0;
const Constants_1 = require("../Constants");
const Gateway_1 = require("./Gateway");
/**
 * Describes an ExclusiveGateway.
 *
 * These gateways are used for conditional branch execution.
 */
class ExclusiveGateway extends Gateway_1.Gateway {
    get bpmnType() {
        return Constants_1.BpmnType.exclusiveGateway;
    }
}
exports.ExclusiveGateway = ExclusiveGateway;
//# sourceMappingURL=ExclusiveGateway.js.map